import { getFilterOptions, getTransactions } from '../../../api';
import { onRequest } from '../..';
import { ActionsType, flattenAll, PropertyType } from '../../../common';
import { getFiltersUrl } from '../../../view/pages/PlayerTransactions/PlayerTransactions.helper';

const transactionsInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { players, pagesTotal } = await getTransactions({
		token,
		page,
		query: '',
		perPage,
	});

	return { players, pagesTotal, currentPage: page };
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;

	return { partners: flattenAll(partners) };
};

const filtersInit = async (payload: PropertyType) => {
	const { token, filters } = payload;
	const resp = await getFilterOptions({ token, filters });
	return { ...resp.data };
};

const filterData = async (token: string, page: string, filters: PropertyType[], perPage: string) => {
	const query = filters.length ? getFiltersUrl(filters) : '';

	// Add guard to prevent api call if no required filters, and update filter values
	if (
		!query.includes('transaction_ids') &&
		!query.includes('start_date') &&
		!query.includes('session_ids') &&
		!query.includes('aams_session_ids') &&
		!query.includes('round_ids')
	) {
		return {
			filters,
			filtering: filters.length > 1,
			isFilterValid: false,
			transactions: [],
			currentPage: 1,
			transactionsLoading: false,
		};
	}

	const { transactions, pagesTotal } = await getTransactions({
		token,
		page,
		query,
		perPage,
	});

	return {
		isFilterValid: true,
		pagesTotal,
		transactions,
		filters,
		filtering: filters.length > 1,
		currentPage: page,
		transactionsLoading: false,
	};
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters, state.perPage);
};

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	return filterData(token, page, state.filters, perPage);
};

const onUpdateColumns = async (payload: PropertyType) => {
	const rawValue = JSON.stringify(payload);
	localStorage.setItem('transactionsList', rawValue);
	return { columns: payload };
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ transactionsLoading: payload }),
	FILTERS_INIT: (state, payload) => onRequest(() => filtersInit(payload)),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	TRANSACTIONS_INIT: (state, payload) => transactionsInit(payload),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	INIT_COLUMNS: (state, payload) => ({
		columns: payload.columns,
		initialColumns: payload.initialColumns,
	}),
	UPDATE_COLUMNS: (state, payload) => onUpdateColumns(payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	FILTER: (state, payload) => onFilter(state, payload),
	UPDATE_FILTERS: (state, payload) => ({ filters: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', transactionsLoading: false }),
};
